import { render, staticRenderFns } from "./VuexConfirmationModal.vue?vue&type=template&id=4b2469e2&scoped=true"
import script from "./VuexConfirmationModal.vue?vue&type=script&lang=js"
export * from "./VuexConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./VuexConfirmationModal.vue?vue&type=style&index=0&id=4b2469e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2469e2",
  null
  
)

export default component.exports